import { Reveal } from "@/components/site/Reveal";
import { scrollToSection } from "@/hooks/useLenis";

const COLS = [
  { title: "Services", links: ["Kitchens", "Bathrooms", "Additions", "Living Spaces"] },
  { title: "Studio", links: ["About", "Process", "Careers", "Journal"] },
];

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="border-t border-white/10 bg-[#111110]"
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-24">
      <Reveal>
        <button
          data-testid="footer-cta"
          onClick={() => scrollToSection("#quote")}
          className="block w-full text-left group"
        >
          <span className="font-serif font-light leading-[0.85] tracking-tighter text-[#F4F3F0] text-[18vw] lg:text-[15vw] group-hover:text-[#C05C3F] transition-colors duration-500">
            Let's talk.
          </span>
        </button>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-12 py-20 border-t border-white/10 mt-8">
        <div>
          <div className="flex items-baseline gap-2">
            <span className="font-serif text-2xl text-[#F4F3F0]">Green Star Renos</span>
            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#C05C3F]">
              / general trading
            </span>
          </div>
          <p className="mt-5 max-w-xs text-sm text-[#F4F3F0]/60 font-light leading-relaxed">
            A design-and-build studio renovating homes with precision, honesty
            and a little obsession.
          </p>
          <div className="mt-6 space-y-1 font-mono text-[11px] tracking-[0.1em] text-[#F4F3F0]/70">
            <p className="text-[#F4F3F0]/85">905 805 7681 · Residential</p>
            <p>1201 – 1200 Bay Street</p>
            <p>Toronto, ON, M54 2A5</p>
          </div>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <h4 className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#F4F3F0]/50 mb-5">
              {c.title}
            </h4>
            <ul className="space-y-3">
              {c.links.map((l) => (
                <li key={l}>
                  <a
                    href="#quote"
                    data-testid={`footer-link-${l.toLowerCase()}`}
                    className="text-sm text-[#F4F3F0]/80 hover:text-[#C05C3F] transition-colors duration-300"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 py-8 border-t border-white/10 font-mono text-[11px] uppercase tracking-[0.15em] text-[#F4F3F0]/40">
        <span>© 2018 Green Star Renos and General Trading.</span>
        <span>Built with craft, not templates.</span>
      </div>
    </div>
  </footer>
);
